<template>
  <!-- The alarm profile section of the alarm plan, as the PDF prints it
       (generateAlarmPlanPDF in utils/helpers.js): the same texts, the same
       order and the same line breaks, in the PDF's language. -->
  <div class="w-full px-2 text-xs text-gray-800">
    <p class="font-bold">{{ label }}</p>
    <!-- the business's customer-specific instruction replaces the standard texts -->
    <template v-if="customInstruction">
      <h5 class="font-bold mt-2 mb-1 text-red-600">{{ t("alarm_pdf.custom_instruction") }}</h5>
      <p style="white-space: pre-line">{{ customInstruction }}</p>
    </template>
    <template v-else>
      <h5 class="font-bold mt-2 mb-1">{{ t("alarm_pdf.primary_input") }}</h5>
      <p style="white-space: pre-line">{{ texts.title }}</p>
      <h5 class="font-bold mt-2 mb-1">{{ t("alarm_pdf.action_in_alarm") }}</h5>
      <p style="white-space: pre-line">{{ texts.desc }}</p>
    </template>
  </div>
</template>

<script>
import { riskProfileLabel, riskProfileTexts, customInstructionText, alarmPlanLocale } from "@/utils/alarmEnums";

export default {
  name: "AlarmProfilePreview",
  props: {
    riskProfile: { type: String, default: "" },
    // the device's business (Unit), for its customer-specific instruction
    unit: { type: Object, default: null },
    // the business's customer: a Dutch customer's plan is in Dutch
    customer: { type: Object, default: null },
  },
  computed: {
    label() {
      return riskProfileLabel(this.t, this.riskProfile);
    },
    texts() {
      return riskProfileTexts(this.t, this.riskProfile);
    },
    customInstruction() {
      return customInstructionText(this.unit);
    },
  },
  methods: {
    // the PDF is written in the site's language (Dutch for a Dutch customer),
    // not the user's UI language
    t(key) {
      return this.$t(key, alarmPlanLocale(this.customer));
    },
  },
};
</script>
